import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from './firebase';
import NavBar from './components/navbar/NavBar';
import pkg from '../package.json';

interface ProtectedRouteProps {
  element: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const appVersion = pkg.version;

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      const token = localStorage.getItem("APP_ACCESS_TOKEN");

      // Verifica se há um usuário autenticado e um token válido
      if (user && token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" />;
  }

  return (
  <div className="flex flex-col min-h-screen bg-indigo-200">
    <NavBar />
    <main className="flex-grow pt-[100px]">
      {element}
    </main>
    <footer className="text-right p-2 text-xs bg-indigo-100 text-gray-800">
      ©wCRM Versão {appVersion}
    </footer>
  </div>
);

};

export default ProtectedRoute;
